import React from "react";
import styled from "styled-components";
import { Card, Empty, Space, Tag, Typography } from "antd";
import { generateDailySummary } from "../services/dailySummaryService.js";

const { Text } = Typography;

const SummaryCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;

  .ant-card-head-title {
    color: #005249;
    font-weight: 700;
  }
`;

const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 12px;
`;

const SummaryTile = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  padding: 12px;
  background: #ffffff;
`;

const DailySummaryWidget = ({ metricGroups, loading = false }) => {
  if (loading) return null;

  const summary = generateDailySummary(metricGroups);
  const hasSignal = summary.source === "deterministic_metric_rules" &&
    summary.observations.some((observation) => observation.key !== "no_major_changes");

  return (
    <SummaryCard
      title="Daily Summary"
      extra={<Tag color={hasSignal ? "blue" : "default"}>{summary.source}</Tag>}
      data-testid="daily-summary-widget"
    >
      <Space direction="vertical" size={14} style={{ width: "100%" }}>
        <Text strong>{summary.headline}</Text>
        {summary.observations.length === 0 ? (
          <Empty description="No summary data available" image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          <SummaryGrid>
            {summary.observations.map((observation) => (
              <SummaryTile key={observation.key}>
                <Space direction="vertical" size={6}>
                  <Tag color="green">{observation.category}</Tag>
                  <Text>{observation.text}</Text>
                </Space>
              </SummaryTile>
            ))}
          </SummaryGrid>
        )}
        {summary.actions.length > 0 && (
          <Space direction="vertical" size={6}>
            <Text strong>Recommended Actions</Text>
            {summary.actions.map((action) => (
              <Text key={action.key} data-drilldown-key={action.drilldownKey}>
                {action.text}
              </Text>
            ))}
          </Space>
        )}
      </Space>
    </SummaryCard>
  );
};

export default DailySummaryWidget;
